import axios from '@/services/request';
import {AxiosPromise} from "axios";
import store from "@/store";
import {Resp, Page} from "@/model/Resp";
import {AmPageQuery, AmPageDetail, DownloadRes, ConfigType} from "@/model/AmPage";

/**
 * 登录
 * @param params
 * @param showLoading
 */
export function login(params: {
  userName: string,   // 用户
  password: string    // 密码
}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/user/login`, params)
}

/**
 * 登出
 * @param params
 * @param showLoading
 */
export function logout(params: {}, showLoading: boolean = false): AxiosPromise {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/user/logout`, {params})
}

/**
 * page列表
 * @param params
 * @param showLoading
 */
export function getPageList(params: AmPageQuery, showLoading: boolean = true): AxiosPromise<Resp<Page<AmPageQuery>>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/page/list`, params)
}

/**
 * page详情
 * @param params
 * @param showLoading
 */
export function getPageDetail(params: {pageId: string}, showLoading: boolean = true): AxiosPromise<Resp<AmPageDetail>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/page/detail`, {params})
}

/**
 * 列表中page状态修改
 * @param params
 * @param showLoading
 */
export function updatePageStatus(params: AmPageDetail, showLoading: boolean = true): AxiosPromise<Resp<AmPageDetail>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/page/updateStatus`, params)
}

/**
 * 列表中page关联发布
 * @param params
 * @param showLoading
 */
export function relationPagePublish(params: AmPageDetail, showLoading: boolean = true): AxiosPromise<Resp<AmPageDetail>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/page/relationPublish`, params)
}

/**
 * page详情修改
 * @param params
 * @param showLoading
 */
export function updatePageDetail(params: AmPageDetail, showLoading: boolean = true): AxiosPromise<Resp<AmPageDetail>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/page/updateDetail`, params)
}

/**
 * 获取配置
 * @param params
 * @param showLoading
 */
export function getConfig(params: {
  type: ConfigType
}, showLoading: boolean = false): AxiosPromise<Resp<{desc: string, code: number}[]>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.get(`/api/config/datas`, {params})
}

/**
 * 获取excel
 */
export function getPageExcel(params: AmPageQuery, showLoading: boolean = false): AxiosPromise<Resp<File>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios({
    url: `/api/page/exportList`,
    method: 'post',
    data: params,
    responseType: 'blob'
  })
}

/**
 * 获取excel模板
 */
export function getTempExcel(params: {}, showLoading: boolean = false): AxiosPromise<Resp<File>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios({
    url: `/api/excel/temp/download`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}

/**
 * 获取失败详情excel模板
 */
export function getFailExcel(params: {requestId: string}, showLoading: boolean = false): AxiosPromise<Resp<File>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios({
    url: `/api/excel/fail/download`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}

/**
 * 保存spu的excel
 */
export function savePageExcel(params: FormData, showLoading: boolean = true): AxiosPromise<Resp<DownloadRes>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/excel/upload/account`, params)
}

/**
 * 保存spu的excel
 */
export function saveAllocateExcel(params: FormData, showLoading: boolean = true): AxiosPromise<Resp<DownloadRes>> {
  showLoading && store.commit('SET_LOADING', true);
  return axios.post(`/api/excel/upload/account/allocate`, params)
}
